module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.theDrugStorage.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "defaultPackCount": 0,
      "deviceId": _vm.forAction.deviceId,
      "onlyPc": true,
      "inputReadOnly": _vm.fetchReadOnly,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount,
      "setTotalSumInstanly": _vm.getTotalSumInstanly
    }
  }, [_c('h5', [_vm._v("自此藥盒取藥數量 (pc)")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'break') ? _c('ActionBreak', {
    attrs: {
      "residual": _vm.amount - _vm.totalAmount
    },
    on: {
      "goOn": _vm.goOn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 'next') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00902265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrugFlow/ActionWrap.vue
// module id = 1360
// module chunks = 1